import { render } from "./SocialButtons.vue?vue&type=template&id=6253bf57&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"

import "./SocialButtons.vue?vue&type=style&index=0&id=6253bf57&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6253bf57"]])

export default __exports__